// extracted by mini-css-extract-plugin
export default {"title":"LbTvy98Cks","button":"YQaJITmzDb"};